export default "__VITE_ASSET__CAFWLGY5__"